import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import MobileJoinForFreeButton from 'bundles/composable-page-header-consumer/components/MobileJoinForFreeButton';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import MobileMenuIconGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuIconGridItem';
import MobileSearchBarGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileSearchBarGridItem';
import DefaultLoggedOutMobileMenuConfig from 'bundles/composable-page-header/module-renderers/DefaultLoggedOutMobileMenuConfig';

type Props = {
  showDiscoveryElements?: boolean;
  showSearch?: boolean;
};

const LoggedOutConsumerMobileMainNav = ({ showDiscoveryElements = true, showSearch = true }: Props) => {
  return (
    <MainNavigationWrapper>
      <Grid item xs={7} sm={6} container alignItems="center">
        <MobileMenuIconGridItem
          menuConfig={<DefaultLoggedOutMobileMenuConfig />}
          homeLogo={<HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} className="c-logo" />}
        />
        <HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} className="c-logo" />
      </Grid>
      <Grid item container xs={5} sm={6} alignItems="center" justifyContent="flex-end">
        {showSearch && showDiscoveryElements && <MobileSearchBarGridItem />}
        <MobileJoinForFreeButton />
      </Grid>
    </MainNavigationWrapper>
  );
};

export default LoggedOutConsumerMobileMainNav;
